'use strict';

var React = require('react');
var Screen = require('../../utils/Screen.js');

var SectionHeader = React.createClass({
    getInitialState: function () {
        return {displayExpand: false};
    },
    onClick: function() {
        this.setState({ displayExpand: !this.state.displayExpand });
    },
    componentDidMount: function() {
        if (this.props.focus){
            this.refs.sectionHeading.scrollIntoView();
            const scrollYPosition = Screen.getScrollYPosition();
            window.scrollTo(0, scrollYPosition - 85);
            this.refs.sectionHeading.focus();
        }
    },
    render: function () {
        var displayStyle = this.state.displayExpand ? { display: 'block' } : { display: 'none' };
        var icon;
        if (this.state.displayExpand) {
            icon = 'icon icon-cancel-circled';
        } else {
            icon = 'icon icon-info-circled';
        }
        //TODO: SANITZE NeedHelpInfo and menuLink
        var markup = { __html: this.props.NeedHelpInfo};
        return (
            <section>
                <nav className="navbar navbar-sub">
                <div className="container">
                    <div className="pull-left">
                        <h3 ref="sectionHeading" tabIndex="-1" className="sectionHeader__sectionName">{this.props.sectionName}</h3>
                    </div>
                    {this.props.sectionHelpText ? <div className="pull-right navbar-help workItem__hidden">
                                                    <span className="hidden-xs needhelp-text">{this.props.sectionHelpText} </span>
                                                    <a className="icon-click" id={this.props.sectionName + '-info-expand'} onClick={this.onClick} ref="icon-click"><i className={icon}></i></a>
                                                </div>
                                                : null}
                </div>
                    <div className="clearfix" />
                    <div style={displayStyle} className="needhelp-info navbar-sub-title">
                    <div className="container context-copy">
                        <p dangerouslySetInnerHTML={markup}></p>
                    </div>
                    </div>
                </nav>
            </section>          
		); 
    }
});

module.exports = SectionHeader;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/SectionHeader.jsx